import { Routes } from '@angular/router';
import { FeaturesComponent as FeaturesContainer } from './features/features.component';
import { LoginComponent } from './auth/login/login.component';
import { standaloneOnlyGuard } from './core/guards/standalone-only/standalone-only.guard';


export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [standaloneOnlyGuard],
  },
  {
    path: 'change-password',
    loadComponent: () => import('./auth/change-password/change-password.component').then(m => m.ChangePasswordComponent),
    canActivate: [standaloneOnlyGuard],
  },
  {
    path: '',
    component: FeaturesContainer,
    loadChildren: () => import('./features/features.routes').then((m) => m.FEATURES_ROUTES),
  },
];
